export default "/images/cast.svg?2d647cdd485588dee2ed9ace5d9b7bcd";